function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

function speedSwitch(speed) {
  if (speed === "fast") return 600;
  if (speed === "slow") return 900;
  return 750;
}

export var Spinner = _ref => {
  var {
    color = "rgba(0,0,0,0.4)",
    speed = "medium",
    gap = 4,
    thickness = 4,
    size = "1em"
  } = _ref,
      props = _objectWithoutProperties(_ref, ["color", "speed", "gap", "thickness", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: size,
    width: size
  }, props, {
    style: {
      animationDuration: "".concat(speedSwitch(speed), "ms")
    },
    className: "__react-svg-spinner_circle",
    role: "img",
    "aria-labelledby": "title desc",
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/React.createElement("title", {
    id: "title"
  }, "Circle loading spinner"), /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Image of a partial circle indicating \"loading.\""), /*#__PURE__*/React.createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "\n      .__react-svg-spinner_circle{\n          transition-property: transform;\n          animation-name: __react-svg-spinner_infinite-spin;\n          animation-iteration-count: infinite;\n          animation-timing-function: linear;\n      }\n      @keyframes __react-svg-spinner_infinite-spin {\n          from {transform: rotate(0deg)}\n          to {transform: rotate(360deg)}\n      }\n    "
    }
  }), /*#__PURE__*/React.createElement("circle", {
    role: "presentation",
    cx: 16,
    cy: 16,
    r: 14 - thickness / 2,
    stroke: color,
    fill: "none",
    strokeWidth: thickness,
    strokeDasharray: Math.PI * 2 * (11 - gap),
    strokeLinecap: "round"
  }));
};
//# sourceMappingURL=Spinner.js.map